"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidePageTabs = void 0;
var _react = require("react");
var _Tabs = require("../../Tabs");
var _View = _interopRequireDefault(require("../../View"));
var _SidePageTabsContext = require("./SidePageTabsContext");
var _hooksTs = require("@gogame/hooks-ts");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label"],
  _excluded2 = ["label"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    tabs: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }
  };
});
var SidePageTabs = exports.SidePageTabs = function SidePageTabs(_ref) {
  var children = _ref.children,
    initialActiveTabId = _ref.activeTabId,
    fetching = _ref.fetching;
  var _useMountedState = (0, _hooksTs.useMountedState)(initialActiveTabId),
    _useMountedState2 = _slicedToArray(_useMountedState, 2),
    activeTabId = _useMountedState2[0],
    setActiveTabId = _useMountedState2[1];
  var _useMountedState3 = (0, _hooksTs.useMountedState)({}),
    _useMountedState4 = _slicedToArray(_useMountedState3, 2),
    counters = _useMountedState4[0],
    setCounters = _useMountedState4[1];
  var tabs = (0, _react.useRef)([]);
  var classes = useStyles();
  var handleChangeTab = (0, _react.useCallback)(function (_e, activeTabId) {
    setActiveTabId(activeTabId);
  }, []);
  var handleRegisterTab = (0, _react.useCallback)(function (_ref2) {
    var label = _ref2.label,
      props = _objectWithoutProperties(_ref2, _excluded);
    tabs.current = [].concat(_toConsumableArray(tabs.current), [_objectSpread({
      label: label
    }, props)]);
  }, []);
  var handleUnregisterTab = (0, _react.useCallback)(function (label) {
    tabs.current = tabs.current.filter(function (el) {
      return el.label !== label;
    });
  }, []);
  var handleSetCount = (0, _react.useCallback)(function (label, count) {
    setCounters(function (_counters) {
      return _objectSpread(_objectSpread({}, _counters), {}, _defineProperty({}, label, count));
    });
  }, [setCounters]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SidePageTabsContext.SidePageTabsContext.Provider, {
    value: {
      activeTabId: activeTabId,
      registerTab: handleRegisterTab,
      unregisterTab: handleUnregisterTab,
      setCount: handleSetCount
    },
    children: [tabs.current.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_View["default"], {
      grow: false,
      fetching: fetching,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.GgTabs, {
        value: activeTabId,
        onChange: handleChangeTab,
        className: classes.tabs,
        children: tabs.current.map(function (_ref3) {
          var label = _ref3.label,
            props = _objectWithoutProperties(_ref3, _excluded2);
          var count = counters[label];
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.GgTab, _objectSpread({
            id: label,
            value: label,
            label: "".concat(label).concat(count ? " (".concat(count, ")") : '')
          }, props), label);
        })
      })
    }) : null, children]
  });
};
SidePageTabs.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].array, _propTypes["default"].node]),
  activeTabId: _propTypes["default"].string,
  fetching: _propTypes["default"].bool
};